import * as types from '../mutation-types'

// state
export const state = {
    toggle: false
};

// getters
export const getters = {
    toggle: state => state.toggle
};

// mutations
export const mutations = {
    [types.SIDEBAR_TOGGLE] (state) {
        state.toggle = !state.toggle;
    }
};

// actions
export const actions = {
    toggle ({ commit }) {
        commit(types.SIDEBAR_TOGGLE);
    }
};
